<style lang="scss"
       module>
@import 'src/brand/brandColors.variables';
</style>
<template>
  <option :value="value">{{ text }}</option>
</template>

<script>
/* Vue Components */
/* Meteor packages */
/* NPM packages */
/* Methods */
/* Everything else */

export default {
  name: 'FormFieldSelectOption',
  props: {
    option: {
      type: Object,
      required: true,
    },
  },
  computed: {
    text() {
      return this.option.name || this.option;
    },
    value() {
      return this.option.value || this.option;
    },
  },
};
</script>
